import React, { useState, useEffect } from "react";
import { useOutletContext } from "react-router-dom";
import { MaterialReactTable } from "material-react-table";
import axios from "axios";
import { Modal, Button, Spinner } from "react-bootstrap";
import EditNoPoach from "../../components/Modals/Contract/EditNoPoach";

function NoPoachList() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();
  const [data, setData] = useState([]);
  const [selectedContractId, setSelectedContractId] = useState(null);
  const [editModel, setEditModel] = useState(false);

  const columns = [
    {
      accessorKey: "contract_id",
      header: "",
      size: 20,
        Cell: ({ row }) => {
        const { contract_status, contract_id, can_edit_no_poach } = row.original;

        if (contract_status === "No Contract" || Number(contract_id) === 0 || Number(can_edit_no_poach) !== 1) {
          return null;
        }

        return (
          <a href="javascript:void(0)"
                onClick={() => OpenEditContractModal(contract_id)}
                title="Edit No-Poach">
              <i className="fa-solid fa-pen"></i>
            </a>
        );
      },
    },
    {
      accessorKey: "ClientName",
      header: "Client Name",
    },
    {
      accessorKey: "BD",
      header: "Business Developed",
    },
    {
      accessorKey: "Industry",
      header: "Industry",
    },
    {
      accessorKey: "contract_status",
      header: "Contract Status",
    },
    {
      accessorKey: "NoPoach",
      header: "No-poach",

      Cell: ({ cell }) => {
        const value = String(cell.getValue() || "").toLowerCase();

        return (
          <span
            className={`badge ${
              value === "yes"
                ? "bg-success"
                : "bg-secondary"
            }`}
          >
            {value === "yes" ? "Yes" : "No"}
          </span>
        );
      },
    },
    {
      accessorKey: "Location",
      header: "No-poach Region/Country",

      Cell: ({ cell, row }) => {
        const noPoach = String(
          row.original.NoPoach || ""
        ).toLowerCase();

        if (noPoach !== "yes") {
          return "-";
        }

        return cell.getValue() || "-";
      },
    },
  ];

  async function fetchNoPoachList() {
    setGlobalLoading(true);

    try {
      const response = await axios.get(
        `${API_BASE_URL}/common_controller/nopoachList`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response.data);
      setData(response.data || []);
    } catch (error) {
      console.error("No Poach API Error:", error);
      setData([]);
    } finally {
      setGlobalLoading(false);
    }
  }

  useEffect(() => {
    fetchNoPoachList();
  }, []);

  const OpenEditContractModal = (contract_id) => {
    setGlobalLoading(true);
    setSelectedContractId(contract_id);
    setEditModel(true);
  };

  return (
    <div className="container-fluid p-4">

      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-3">

        <h5 className="mb-0">
          No Poach List
        </h5>
      </div>
    {editModel && (
        <EditNoPoach
          id={selectedContractId}
          onClose={() => {
            setEditModel(false);
            fetchNoPoachList();
          }}
        />
      )}

      {/* MAIN TABLE */}
      <MaterialReactTable
        columns={columns}
        data={data}
        enableStickyHeader
        muiTableContainerProps={{
          sx: {
            maxHeight: "70vh",
          },
        }}
        initialState={{
          pagination: {
            pageIndex: 0,
            pageSize: 100,
          },
        }}
      />
    </div>
  );
}

export default NoPoachList;